export const PRISTINE_SETTINGS = {
  classTo: 'field-wrapper',
  errorClass: 'field-wrapper--error',
  successClass: 'field-wrapper--success',
  errorTextParent: 'field-wrapper',
  errorTextTag: 'span',
  errorTextClass: 'field__msg--error'
};

export const SERIALIZE_SETTINGS = {
  hash: true,
  disabled: true,
  empty: true
};
